var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-autosuggest',{ref:"setValue",attrs:{"suggestions":_vm.options,"limit":10,"input-props":_vm.inputProps},on:{"selected":_vm.onSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }